import { AppProps } from 'next/app';
import TagManager from 'react-gtm-module';
import React from 'react';
import Head from 'next/head';
import withApollo from '../lib/graphql/withApollo';
import '../styles/globals.css';
import appConfig from '../config/appConfig';
import { AppEnvironment } from '../config/env';

if (
  typeof document !== 'undefined' &&
  appConfig.env.NEXT_PUBLIC_ENVIRONMENT !== AppEnvironment.DEVELOPMENT
) {
  TagManager.initialize({
    gtmId: 'GTM-P3V2VR5',
  });
}

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <title>Ally advokater</title>
      </Head>

      <Component {...pageProps} />
    </>
  );
}

export default withApollo(MyApp);
